import { Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';

import { useFilterState } from '../../hooks/useFilterState';
import { DataTableFilterOption, DataTableFilterType } from '../../utils/typings';
import { FilterPopoverContent } from '../FilterPopoverButton';

type Props<T extends DataTableFilterType> = {
  value: string[];
  options: DataTableFilterOption<T>[];
  onChange: (value: string[]) => void;
  onSubmit: () => void;
};

export const CheckboxFilterPopoverContent = <T extends DataTableFilterType>({
  value,
  options,
  onChange,
  onSubmit,
}: Props<T>) => {
  const state = useFilterState({
    defaultValue: value,
    onSubmit,
  });

  const handleChange = (nextValue: string[]) => {
    onChange(nextValue);
    state.onChange(nextValue);
  };

  const renderOption = (option: DataTableFilterOption<T>) => (
    <Checkbox key={String(option?.value)} value={String(option?.value)}>
      {option?.label}
    </Checkbox>
  );

  return (
    <FilterPopoverContent onClickApply={state.onSubmit} onClickCancel={state.onReset}>
      <CheckboxGroup value={state.value} onChange={handleChange}>
        <Stack>{options?.map(renderOption)}</Stack>
      </CheckboxGroup>
    </FilterPopoverContent>
  );
};
